import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { MaintenanceService } from '../services/maintenance.service';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceGuard implements CanActivate, CanActivateChild {
  private isBrowser: boolean;
  constructor(private maintenanceService: MaintenanceService, private router: Router,
     @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  canActivate(): Observable<boolean> {
    if (this.isBrowser) {
      return this.checkMaintenanceStatus();
    }
    // If not in the browser, allow navigation
    return of(true);
  }

  canActivateChild(): Observable<boolean> {
    if (this.isBrowser) {
      return this.checkMaintenanceStatus();
    }
    // If not in the browser, allow navigation
    return of(true);
  }

  private checkMaintenanceStatus(): Observable<boolean> {
    return this.maintenanceService.getMaintenanceSchedule().pipe(
      map((res: any) => {
        if (res.data && res.data.isActive) {
          const now = new Date().getTime();
          const from = new Date(res.data.fromDateTime).getTime();
          const to = new Date(res.data.toDateTime).getTime();

          if (now >= from && now <= to) {
            this.router.navigate(['/maintenance']);
            return false;
          }
        }
        return true; // Allow navigation if not in maintenance
      }),
      catchError(() => {
        return of(true); // Allow navigation in case of API error
      })
    );
  }
}
